import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import TagIcon from '@mui/icons-material/Tag';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import type {SxProps} from '@mui/system';
import {lighten} from '@mui/system/colorManipulator';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import ValueLabel from '@/components/common/ValueLabelForPopUp';
import type {ForestMassStatus} from '@/domain/entities/ForestMassStatus';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  forestMassStatus: ForestMassStatus;
  onClick: (uuid: string) => void;
};

const ForestMassPopupContent: FC<Props> = ({forestMassStatus, onClick}) => {
  const {t} = useTranslation();
  const {forestMassUuid, code, concello, plannedCuttingDate} = forestMassStatus;

  return (
    <Box sx={styles.container}>
      <Stack sx={{m: 1}}>
        {concello && (
          <ValueLabel
            value={concello}
            icon={<LocationOnOutlinedIcon sx={{color: 'grey.700'}} />}
            label={t('forestMass.concello')}
          />
        )}
        <Divider />
        {code && (
          <ValueLabel
            value={code.toUpperCase()}
            icon={<TagIcon sx={{color: 'grey.700'}} />}
            label={t('forestMass.code')}
          />
        )}
        <Divider />
        {plannedCuttingDate && (
          <ValueLabel
            value={plannedCuttingDate.format('YYYY-MM-DD').toString() || '-'}
            icon={<CalendarTodayOutlinedIcon sx={{color: 'grey.700'}} />}
            label={t('forestMass.plannedCuttingDate')}
          />
        )}
        <Button
          variant="contained"
          sx={{bgcolor: lighten(primaryColor, 0.5), color: 'primary.main', mt: 1}}
          onClick={() => onClick(forestMassUuid)}
        >
          {t('forestMass.viewDetail')}
        </Button>
      </Stack>
    </Box>
  );
};
export default ForestMassPopupContent;

const styles: Record<string, SxProps> = {
  container: {
    width: 'auto',
    maxWidth: '90vw',
    boxSizing: 'border-box',
    margin: '4px',
  },
  title: {
    fontWeight: 700,
    color: 'primary.main',
    mb: 1,
  },
  icon: {
    color: 'primary.dark',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    ml: 0.5,
    color: 'primary.main',
    fontWeight: 'bold',
  },
};
